import React from "react";
import { actions } from "frequencyscreen_v_dbinder";
import { NamespacesConsumer, translate } from "react-i18next";
import { withRouter } from "react-router-dom";
import { languageOptions, Permissions } from "../../utils";
import { LoggerContext } from "../../contexts";
import IDMPANEL from "idmpanel-pkg";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../config";
import cookie from "react-cookies";

import * as ALL from "../../components";
import { Modal } from "qdm-component-library";
import { Grid, Typography, TextField } from "@material-ui/core";

import { Autocomplete } from "@material-ui/lab";
import qdmstyles from "./styles.json";
import "./index.css";
var aes256 = require("aes256");

function Schedulelines5(props) {
  const dispatch = useDispatch();

  const contextType = React.useContext(LoggerContext);
  const [state, setState] = React.useState({
    permissionData: null,
  });

  const changeState = (key, value) => {
    setState({
      ...state,
      [key]: value,
    });
  };

  React.useEffect(() => {
    /// initializing transalation
    if (localStorage.defaultLng) {
      const { i18n } = props;
      i18n.changeLanguage(localStorage.defaultLng);
    }
    /// setlogger && dispatch of all events

    /// fetch all permission
  }, []);

  ///fetching all permission

  React.useEffect(() => {}, [state]);

  return (
    <NamespacesConsumer>
      {(t, { i18n }) => (
        <React.Fragment>
          <Grid
            key={"0"}
            id={"DGwzy"}
            container={true}
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            aliasName={"day based"}
          >
            <Grid
              key={"0"}
              id={"Sqq4d"}
              container={true}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              item={true}
              lg={"12"}
              style={qdmstyles.cwrR}
            >
              <Grid
                key={"0"}
                id={"kWbw8"}
                container={false}
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography
                  key={"0"}
                  id={"WSZqV"}
                  align={"inherit"}
                  color={"initial"}
                  display={"initial"}
                  variant={"body1"}
                  children={"SCHEDULE LINES"}
                  style={qdmstyles.ZsG}
                ></Typography>
              </Grid>
            </Grid>
            <Grid
              key={"1"}
              id={"dHOGr"}
              container={true}
              direction={"row"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              item={true}
              lg={"12"}
              spacing={"1"}
              md={"12"}
              sm={"12"}
            >
              <Grid
                key={"0"}
                id={"kstWr"}
                container={true}
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                item={true}
                lg={"2"}
                md={"2"}
                sm={"2"}
                style={qdmstyles.oQHn}
              >
                <Grid
                  key={"0"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <Typography
                    key={"0"}
                    id={"Y8M1c"}
                    align={"inherit"}
                    color={"initial"}
                    display={"initial"}
                    variant={"body1"}
                    children={"day"}
                    style={qdmstyles.tZSX}
                  ></Typography>
                </Grid>
                <Grid
                  key={"1"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                  sm={"12"}
                >
                  <Autocomplete
                    id={"idTOz"}
                    style={qdmstyles?.idTOz}
                    value={state?.schedulelines5_idtoz ?? null}
                    onLoad={() =>
                      setState({
                        schedulelines5_idtoz:
                          state?.schedulelines5_idtoz ?? null,
                      })
                    }
                    getOptionLabel={(option) => option?.["label"]}
                    options={[]}
                    onChange={(e, newvalue) =>
                      setState({ schedulelines5_idtoz: newvalue })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"label"}
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  key={"2"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <Autocomplete
                    id={"Qu1ew"}
                    style={qdmstyles?.Quew}
                    value={state?.schedulelines5_qu1ew ?? null}
                    onLoad={() =>
                      setState({
                        schedulelines5_qu1ew:
                          state?.schedulelines5_qu1ew ?? null,
                      })
                    }
                    getOptionLabel={(option) => option?.["label"]}
                    options={[]}
                    onChange={(e, newvalue) =>
                      setState({ schedulelines5_qu1ew: newvalue })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"label"}
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                key={"1"}
                id={"kstWr"}
                container={true}
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                item={true}
                lg={"2"}
                md={"2"}
                sm={"2"}
                style={qdmstyles.rRdv}
              >
                <Grid
                  key={"0"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <Typography
                    key={"0"}
                    id={"Y8M1c"}
                    align={"inherit"}
                    color={"initial"}
                    display={"initial"}
                    variant={"body1"}
                    children={"Base Frequency"}
                    style={qdmstyles.HQaO}
                  ></Typography>
                </Grid>
                <Grid
                  key={"1"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                  sm={"12"}
                >
                  <Autocomplete
                    id={"zO7Hg"}
                    style={qdmstyles?.zOHg}
                    value={state?.schedulelines5_zo7hg ?? null}
                    onLoad={() =>
                      setState({
                        schedulelines5_zo7hg:
                          state?.schedulelines5_zo7hg ?? null,
                      })
                    }
                    getOptionLabel={(option) => option?.["label"]}
                    options={[]}
                    onChange={(e, newvalue) =>
                      setState({ schedulelines5_zo7hg: newvalue })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"label"}
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  key={"2"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <Autocomplete
                    id={"TtZku"}
                    style={qdmstyles?.TtZku}
                    value={state?.schedulelines5_ttzku ?? null}
                    onLoad={() =>
                      setState({
                        schedulelines5_ttzku:
                          state?.schedulelines5_ttzku ?? null,
                      })
                    }
                    getOptionLabel={(option) => option?.["label"]}
                    options={[]}
                    onChange={(e, newvalue) =>
                      setState({ schedulelines5_ttzku: newvalue })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"label"}
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                key={"2"}
                id={"kstWr"}
                container={true}
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                item={true}
                lg={"6"}
                md={"6"}
                sm={"6"}
                style={qdmstyles.nSwzz}
              >
                <Grid
                  key={"0"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                >
                  <Typography
                    key={"0"}
                    id={"Y8M1c"}
                    align={"inherit"}
                    color={"initial"}
                    display={"initial"}
                    variant={"body1"}
                    children={"Remarks"}
                    style={qdmstyles.MYZr}
                  ></Typography>
                </Grid>
                <Grid
                  key={"1"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <TextField
                    key={"0"}
                    id={"saQ6c"}
                    label={"name"}
                    placeholder={"name"}
                    type={"text"}
                    variant={"outlined"}
                    margin={"dense"}
                    size={"small"}
                    fullWidth={true}
                  ></TextField>
                </Grid>
                <Grid
                  key={"2"}
                  id={"nk8iA"}
                  container={false}
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  lg={"12"}
                  md={"12"}
                >
                  <TextField
                    key={"0"}
                    id={"saQ6c"}
                    label={"name"}
                    placeholder={"name"}
                    type={"text"}
                    variant={"outlined"}
                    margin={"dense"}
                    size={"small"}
                    fullWidth={true}
                  ></TextField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </NamespacesConsumer>
  );
}

export default withRouter(translate()(Schedulelines5));
